import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { AccountPageConfig } from '@front-platform/content-builder';
import { accountPageResolveConfig } from '@front-platform/content-builder';
import { Component, OnInit, input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavigationHistoryService } from '@core/services/navigation-history/navigation-history.service';
export interface AccountPageRuntimeConfig {
  'body'?: any;
}

export type AccountPageConfigInput = Partial<
  Omit<AccountPageConfig, keyof AccountPageRuntimeConfig> & AccountPageRuntimeConfig
>;
export type AccountPageResolvedConfig = Omit<AccountPageConfig, keyof AccountPageRuntimeConfig> &
  Partial<AccountPageRuntimeConfig>;
export interface AccountPageContract extends ConfigComponentContract<
  AccountPageConfigInput,
  AccountPageResolvedConfig
> {}

@Component({
  selector: 'app-account-page',
  templateUrl: './account-page.component.html',
  standalone: false,
})
export class AccountPageComponent implements OnInit, AccountPageContract {
  readonly config = input<AccountPageConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<AccountPageConfig, AccountPageRuntimeConfig>(
    accountPageResolveConfig,
    () => ({ config: this.config() }),
  );
  get body(): any {
    return this.resolvedConfig()['body'] as unknown as any;
  }

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly navigationHistoryService: NavigationHistoryService,
  ) {}

  ngOnInit(): void {
    this.navigationHistoryService.pushStateFromActivatedRouteSnapshot(
      'user-account',
      this.activatedRoute.snapshot,
    );
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(AccountPageComponent, { 'keyAliases': {} });
